exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-actions {\r\n  -ms-flex-pack: space-evenly;\r\n      justify-content: space-evenly;\r\n}\r\n.imgAssegno{\r\n  max-width: 100%;\r\n}\r\n.marked{\r\n  padding:1em;\r\n  border:3px solid black;\r\n  display:inline-block;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/incassi/distinta-assegni.component.css
// module id = ../../../../../src/app/components/incassi/distinta-assegni.component.css
// module chunks = main